import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const HirePromotionBoostIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 21 16", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <path d="M2.0794 1.94565e-10L0.557129 1.88L5.5018 8L0.557129 14.12L2.0794 16L8.55713 8L2.0794 1.94565e-10Z" fill="white" fillOpacity="0.6"/>
            <path d="M8.0794 1.94565e-10L6.55713 1.88L11.5018 8L6.55713 14.12L8.0794 16L14.5571 8L8.0794 1.94565e-10Z" fill="white" fillOpacity="0.8"/>
            <path d="M14.0794 1.94565e-10L12.5571 1.88L17.5018 8L12.5571 14.12L14.0794 16L20.5571 8L14.0794 1.94565e-10Z" fill="white"/>
        </SvgIcon>
    );
};
